function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import dayjs from 'dayjs';
import { isFunction } from 'lodash';
export var TYPE_DATE = ['NOW', 'FOREVER'];
export var TYPE_DATE_MAP = {
  NOW: '至今',
  FOREVER: '永久有效'
};
export var TYPE_DATE_COLS = [{
  value: 'NOW',
  label: '至今'
}, {
  value: 'FOREVER',
  label: '永久有效'
}];
export var ZHI_DATA_SOURCE = [{
  label: '至',
  value: '至'
}];
export var YEAR = 'YEAR';
export var YEAR_RANGE = 'YEAR_RANGE';
export var MONTH = 'MONTH';
export var MONTH_RANGE = 'MONTH_RANGE';
export var DATE = 'DATE';
export var DATE_RANGE = 'DATE_RANGE';
export var DATE_TIME = 'DATE_TIME';
export var DATE_TIME_RANGE = 'DATE_TIME_RANGE';
export var TIME = 'TIME';
export var TIME_RANGE = 'TIME_RANGE';
export var NOW = dayjs();
export var MIN_DATE = dayjs('2000-01-01 00:00:00');
export var MAX_DATE = dayjs('2099-12-31 23:59:59');
export var GET_DATE_NOW = function GET_DATE_NOW() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MIN_DATE;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_DATE;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  if (!min) {
    min = MIN_DATE;
  }
  if (!max) {
    max = MAX_DATE;
  }
  var minDate = dayjs.isDayjs(min) ? min : dayjs(min);
  var maxDate = dayjs.isDayjs(max) ? max : dayjs(max);
  if (NOW.isAfter(minDate, type) && NOW.isBefore(maxDate, type) || NOW.isSame(minDate, type) || NOW.isSame(maxDate, type)) {
    return {
      label: dayjs().format(DEFAULT_DISPLAY_FORMAT.DATE_TIME),
      value: dayjs().format(DEFAULT_VALUE_FORMAT.DATE_TIME)
    };
  }
};
export var NOW_YEAR = NOW.year();
export var NOW_MONTH = NOW.month() + 1;
export var NOW_DAY = NOW.date();
export var DEFAULT_DISPLAY_FORMAT = {
  YEAR: 'YYYY',
  YEAR_RANGE: 'YYYY',
  MONTH: 'YYYY-MM',
  MONTH_RANGE: 'YYYY-MM',
  DATE: 'YYYY-MM-DD',
  DATE_RANGE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  DATE_TIME_RANGE: 'YYYY-MM-DD HH:mm:ss',
  TIME: 'HH:mm:ss',
  TIME_RANGE: 'HH:mm:ss'
};
export var DEFAULT_VALUE_FORMAT = {
  YEAR: 'YYYY',
  YEAR_RANGE: 'YYYY',
  MONTH: 'YYYY-MM',
  MONTH_RANGE: 'YYYY-MM',
  DATE: 'YYYY-MM-DD',
  DATE_RANGE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  DATE_TIME_RANGE: 'YYYY-MM-DD HH:mm:ss',
  TIME: 'HH:mm:ss',
  TIME_RANGE: 'HH:mm:ss'
};
export var dateValueDisplay = function dateValueDisplay(value, props, type) {
  if ('TIME' === type && value) {
    value = "2000-01-01 ".concat(value);
  }
  if ('TIME_RANGE' === type && value && value.length) {
    var _value = value,
      _value2 = _slicedToArray(_value, 2),
      v1 = _value2[0],
      v2 = _value2[1];
    value = [_typeof(v1) === 'object' ? {
      value: TYPE_DATE.includes(v1.value) ? v1.value : "2000-01-01 ".concat(v1.value)
    } : TYPE_DATE.includes(v1) ? v1 : "2000-01-01 ".concat(v1), _typeof(v2) === 'object' ? {
      value: TYPE_DATE.includes(v2.value) ? v2.value : "2000-01-01 ".concat(v2.value)
    } : TYPE_DATE.includes(v2) ? v2 : "2000-01-01 ".concat(v2)];
  }
  var labelInValue = props.labelInValue;
  if (!value || Array.isArray(value) && value.length === 0) {
    return {
      displayValue: undefined,
      pickerValue: undefined
    };
  }
  if (Array.isArray(value)) {
    var _value3 = value,
      _value4 = _slicedToArray(_value3, 2),
      start = _value4[0],
      end = _value4[1];
    return {
      displayValue: [formatDateToDisplay(start, props, type), formatDateToDisplay(end, props, type)],
      pickerValue: labelInValue ? value : [start ? {
        value: start,
        label: formatDateToDisplay(start, props, type)
      } : undefined, end ? {
        value: end,
        label: formatDateToDisplay(end, props, type)
      } : undefined]
    };
  }
  return {
    displayValue: formatDateToDisplay(value, props, type),
    pickerValue: labelInValue ? value : value ? {
      value: value,
      label: formatDateToDisplay(value, props, type)
    } : undefined
  };
};
export var formatDateToDisplay = function formatDateToDisplay(value, props, type) {
  var displayFormat = props.displayFormat;
  var val = value;
  if (_typeof(val) === 'object') {
    val = val.value;
  }
  if (TYPE_DATE.includes(val)) {
    return TYPE_DATE_MAP[val];
  }
  if (val && displayFormat) {
    if (typeof displayFormat === 'string') {
      val = dayjs(val).format(displayFormat);
    } else if (isFunction(displayFormat)) {
      val = displayFormat(val);
    }
  } else if (val) {
    val = dayjs(val).format(DEFAULT_DISPLAY_FORMAT[type]);
  }
  return val;
};
var formatDateValueToData = function formatDateValueToData(v, props, type) {
  var valueFormat = props.valueFormat,
    labelInValue = props.labelInValue;
  var vStr = v;
  if (_typeof(vStr) === 'object') {
    vStr = vStr.value;
  }
  if (TYPE_DATE.includes(vStr)) {
    vStr = vStr;
  } else if (vStr && valueFormat) {
    if (typeof valueFormat === 'string') {
      vStr = dayjs(vStr).format(valueFormat);
    } else if (isFunction(valueFormat)) {
      vStr = valueFormat(vStr);
    }
  } else if (['TIME', 'TIME_RANGE'].includes(type) && vStr) {
    var vs = dayjs(vStr).format('HH:mm');
    return labelInValue ? {
      value: vs,
      label: formatDateToDisplay(vStr, props, type)
    } : vs;
  }
  return labelInValue ? {
    value: vStr,
    label: formatDateToDisplay(vStr, props, type)
  } : vStr;
};
export var dateValueFormat = function dateValueFormat(v, props, type) {
  if (Array.isArray(v)) {
    var _v = _slicedToArray(v, 2),
      v1 = _v[0],
      v2 = _v[1];
    return [formatDateValueToData(v1, props, type), formatDateValueToData(v2, props, type)];
  }
  return formatDateValueToData(v, props, type);
};
export var getYearsDataSource = function getYearsDataSource(minDate, maxDate) {
  var min = minDate ? dayjs.isDayjs(minDate) ? minDate.year() : dayjs(minDate).year() : 2000;
  var max = maxDate ? dayjs.isDayjs(maxDate) ? maxDate.year() : dayjs(maxDate).year() : 2099;
  var i = min;
  var result = [];
  while (i <= max) {
    result.push({
      label: "".concat(i),
      value: "".concat(i)
    });
    i++;
  }
  return result;
};
export var getMonthsOfYear = function getMonthsOfYear(year, minDate, maxDate) {
  var minYear = minDate ? dayjs.isDayjs(minDate) ? minDate.year() : dayjs(minDate).year() : 2000;
  var maxYear = maxDate ? dayjs.isDayjs(maxDate) ? maxDate.year() : dayjs(maxDate).year() : 2099;
  var i = year === minYear && minDate ? dayjs.isDayjs(minDate) ? minDate.month() + 1 : dayjs(minDate).month() + 1 : 1;
  var max = year === maxYear && maxDate ? dayjs.isDayjs(maxDate) ? maxDate.month() + 1 : dayjs(maxDate).month() + 1 : 12;
  var result = [];
  while (i <= max) {
    result.push({
      label: "".concat(i),
      value: "".concat(i)
    });
    i++;
  }
  return result;
};
export var getDaysOfYearMonth = function getDaysOfYearMonth(year, month, minDate, maxDate) {
  var ym = dayjs("".concat(year, "-").concat(month)).format('YYYY-MM');
  var minYM = minDate ? dayjs.isDayjs(minDate) ? minDate.format('YYYY-MM') : dayjs(minDate).format('YYYY-MM') : "2000-01";
  var maxYM = maxDate ? dayjs.isDayjs(maxDate) ? maxDate.format('YYYY-MM') : dayjs(maxDate).format('YYYY-MM') : "2099-12";
  var i = ym === minYM && minDate ? dayjs.isDayjs(minDate) ? minDate.date() : dayjs(minDate).date() : 1;
  var max = ym === maxYM && maxDate ? dayjs.isDayjs(maxDate) ? maxDate.date() : dayjs(maxDate).date() : dayjs(ym).daysInMonth();
  var result = [];
  while (i <= max) {
    result.push({
      label: "".concat(i),
      value: "".concat(i)
    });
    i++;
  }
  return result;
};
export var getHoursOfDate = function getHoursOfDate(year, month, day, minDate, maxDate) {
  var ymd = dayjs("".concat(year, "-").concat(month, "-").concat(day)).format('YYYY-MM-DD');
  var minYMD = minDate ? dayjs.isDayjs(minDate) ? minDate.format('YYYY-MM-DD') : dayjs(minDate).format('YYYY-MM-DD') : "2000-01-01";
  var maxYMD = maxDate ? dayjs.isDayjs(maxDate) ? maxDate.format('YYYY-MM-DD') : dayjs(maxDate).format('YYYY-MM-DD') : "2099-12-31";
  var i = ymd === minYMD && minDate ? dayjs.isDayjs(minDate) ? minDate.hour() : dayjs(minDate).hour() : 0;
  var max = ymd === maxYMD && maxDate ? dayjs.isDayjs(maxDate) ? maxDate.hour() : dayjs(maxDate).hour() : 23;
  var result = [];
  while (i <= max) {
    result.push({
      label: "".concat(i),
      value: "".concat(i)
    });
    i++;
  }
  return result;
};
var MINUTE_FORMAT = 'YYYY-MM-DD HH';
export var buildCompleteDate = function buildCompleteDate(date) {
  if (dayjs.isDayjs(date)) {
    return date;
  }
  if (dayjs(date).isValid()) {
    return date;
  }
  if (dayjs("2000-01-01 ".concat(date)).isValid()) {
    return "2000-01-01 ".concat(date);
  }
  return date;
};
export var getMinutesOfDateHour = function getMinutesOfDateHour(year, month, day, hour, minDate, maxDate) {
  var ymd = dayjs("".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour)).format(MINUTE_FORMAT);
  var minYMD = minDate ? dayjs.isDayjs(minDate) ? minDate.format(MINUTE_FORMAT) : dayjs(minDate).format(MINUTE_FORMAT) : "2000-01-01 00";
  var maxYMD = maxDate ? dayjs.isDayjs(maxDate) ? maxDate.format(MINUTE_FORMAT) : dayjs(maxDate).format(MINUTE_FORMAT) : "2099-12-31 23";
  var i = ymd === minYMD && minDate ? dayjs.isDayjs(minDate) ? minDate.minute() : dayjs(minDate).minute() : 0;
  var max = ymd === maxYMD && maxDate ? dayjs.isDayjs(maxDate) ? maxDate.minute() : dayjs(maxDate).minute() : 59;
  var result = [];
  while (i <= max) {
    result.push({
      label: "".concat(i),
      value: "".concat(i)
    });
    i++;
  }
  return result;
};
export var getMonthDaysForCalendar = function getMonthDaysForCalendar(date) {
  var currentMonth = dayjs(date);
  var result = [];
  var monthFirstDay = dayjs(date).startOf('month');
  var monthFirstDayOfWeek = monthFirstDay.day() ? monthFirstDay.day() : 7;
  var operateDay = monthFirstDay.subtract(monthFirstDayOfWeek - 1, 'day');
  var arr = [];
  var isContinue = true;
  while (isContinue) {
    arr.push({
      day: operateDay.date(),
      dateStr: operateDay.format('YYYY-MM-DD'),
      date: operateDay.clone(),
      month: operateDay.month(),
      dayOfWeek: operateDay.day() ? monthFirstDay.day() : 7
    });
    if (arr.length === 7) {
      result.push(_toConsumableArray(arr));
      arr = [];
      if (operateDay.month() !== currentMonth.month() && result.length === 6) {
        isContinue = false;
      }
    }
    operateDay = operateDay.clone().add(1, 'day');
  }
  return {
    days: result,
    month: currentMonth,
    monthStr: currentMonth.format('YYYY年M月')
  };
};